import React from "react";

const SmallHeader = ({
  className,
  ...rest
}: React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => (
  <div className={`${className} uppercase text-md text-secondary`} {...rest} />
);

export default SmallHeader;
